import {Injectable} from '@angular/core';
import {RouterModule, Routes, Router} from '@angular/router';
import {LanguageService} from '../language/language.service';
@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(private router: Router, private language: LanguageService) {}

  navigateTo(route, lang?, params?) {
    if (!lang) {
      let symbol = this.language.getLanguage() + '/';
      let _route = symbol + route;
      if(params)
      {
        let query = params.substring(1);
        query = JSON.parse('{"' + decodeURI(query).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}')
        //console.log('aaaaaa', query)
        return this.router.navigate([_route], {queryParams:query});
       
      }
      this.router.navigate([_route]);
      return;
     
    }
   
    this.router.navigate(['/', lang]);
  }
}
